import { put, select, takeEvery, takeLatest, all, cancel } from 'redux-saga/effects';
import { get } from 'lodash';
import { TARGETING_TACTICS_VIEW, CREATIVES_REPORT_VIEW } from 'constants/capabilities';
import { notify } from '@mrlannigan/reapop';
import { sagaError } from 'helpers/handleGenericSagaError';
import apiAuthCall from 'helpers/apiAuthCall';
import { setMetaSiteDirectChannels } from 'services/entities/duck';
import {
    actions,
    fetchIOChannelSuccess,
    fetchIOChannelCalloutsSuccess,
    fetchIOChannelCreativesSuccess,
    fetchIOChannelTargetingTacticsSuccess,
    fetchIOChannelPlacementsSuccess,
    fetchIOChannelActivitiesSuccess,
    fetchIOChannelsSuccess
} from './duck';

import {
    siteIOChannelDataEndpoint,
    siteIOChannelCalloutsEndpoint,
    siteIOChannelCreativesEndpoint,
    siteIOChannelTargetingTacticsEndpoint,
    siteIOChannelPlacementsEndpoint,
    siteIOChannelActivitiesEndpoint,
    siteIOChannelsEndpoint
} from './selectors';

export function* fetchIOChannels(api, action) {
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(siteIOChannelsEndpoint, action.payload)
            }
        );

        const { data } = result;

        yield put(fetchIOChannelsSuccess(data));
        yield put(setMetaSiteDirectChannels(data.channels));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export function* fetchIOChannel(api, action) {
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(siteIOChannelDataEndpoint, action.payload)
            }
        );

        yield put(fetchIOChannelSuccess(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export function* fetchIOChannelCallouts(api, action) {
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(siteIOChannelCalloutsEndpoint, action.payload)
            }
        );

        yield put(fetchIOChannelCalloutsSuccess(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export function* fetchIOChannelCreatives(api, action) {
    const state = action.getState();

    // Race Condition: Current User may not have returned, so if there is no scope
    // to check against, make the API call as a fallback.
    const scope = get(state, 'users.currentUser.scope', null);
    if (!scope || scope.includes(CREATIVES_REPORT_VIEW)) {
        try {
            const result = yield apiAuthCall(
                state,
                [api, api.request],
                {
                    method: 'get',
                    url: yield select(siteIOChannelCreativesEndpoint, action.payload)
                }
            );

            yield put(fetchIOChannelCreativesSuccess(result.data));
        } catch (err) {
            yield put(notify({
                id: action.payload.transactionId,
                ...sagaError(err)
            }));
        }
    } else {
        yield cancel();
    }
}

export function* fetchIOChannelTargetingTactics(api, action) {
    const state = action.getState();
    // Race Condition: Current User may not have returned, so if there is no scope
    // to check against, make the API call as a fallback.
    const scope = get(state, 'users.currentUser.scope', null);
    if (!scope || scope.includes(TARGETING_TACTICS_VIEW)) {
        try {
            const result = yield apiAuthCall(
                state,
                [api, api.request],
                {
                    method: 'get',
                    url: yield select(siteIOChannelTargetingTacticsEndpoint, action.payload)
                }
            );
            yield put(fetchIOChannelTargetingTacticsSuccess(result.data));
        } catch (err) {
            yield put(notify({
                id: action.payload.transactionId,
                ...sagaError(err)
            }));
        }
    } else {
        yield cancel();
    }
}

export function* fetchIOChannelPlacements(api, action) {
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(siteIOChannelPlacementsEndpoint, action.payload)
            }
        );

        yield put(fetchIOChannelPlacementsSuccess(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export function* fetchIOChannelActivities(api, action) {
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(siteIOChannelActivitiesEndpoint, action.payload)
            }
        );

        yield put(fetchIOChannelActivitiesSuccess(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export default function* channelSagas({ api }) {
    yield all([
        takeLatest(actions.FETCH_CHANNELS, fetchIOChannels, api),
        takeEvery(actions.FETCH_DATA, fetchIOChannel, api),
        takeEvery(actions.FETCH_CALLOUTS, fetchIOChannelCallouts, api),
        takeEvery(actions.FETCH_CREATIVES, fetchIOChannelCreatives, api),
        takeEvery(actions.FETCH_TARGETING_TACTICS, fetchIOChannelTargetingTactics, api),
        takeEvery(actions.FETCH_PLACEMENTS, fetchIOChannelPlacements, api),
        takeEvery(actions.FETCH_ACTIVITIES, fetchIOChannelActivities, api),
    ]);
}



// WEBPACK FOOTER //
// ./src/services/siteDirect/saga.js